import React from "react";
import { useNavigate } from "react-router-dom";
import { FaSignOutAlt, FaUserCircle  } from "react-icons/fa";
import "./Header.css"; // make sure this path is correct
import Logo from "../assets/mobile_logo.jpg"

const Header = () => {
  const navigate = useNavigate();
  const affiliateName = localStorage.getItem("AffiliateName") || "Affiliate";

  const handleLogout = () => {
    localStorage.clear();
    navigate("/unauthorized");
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* Left: Logo + Courses */}
        <div className="header-left">
          <img src={Logo} alt="Logo" className="logo" />
          <h3 className="course-menu" onClick={() => navigate("/courses")}>
            Courses
          </h3>
        </div>

        {/* Right: Affiliate name + Logout */}
        <div className="header-right">
          <div className="profile-container">
            <FaUserCircle className="profile-icon" />
            <span className="affiliate-name">{affiliateName}</span>
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            <FaSignOutAlt className="logout-icon" /> <span>Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
